import { render } from "./select-existing-document.vue?vue&type=template&id=8e135f9e"
import script from "./select-existing-document.vue?vue&type=script&lang=js"
export * from "./select-existing-document.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__